// src/lib/chartApi.js
//
// Axios helpers for the takso-service /report-builder/* endpoints.
//
// Usage:
//   import { chartApiGet, reportBuilderGet, reportBuilderPut } from '../../lib/chartApi';
//   const data = await chartApiGet('outcome-measures', { programIds: '1,2,3' });
//   const data = await reportBuilderGet('activity-venues', { activityId: 42 });
//   const data = await reportBuilderPut('preferences', { orgId: 42 }, { document: { fontFamily: 'Georgia' } });

import axios from 'axios';

/** Strip null / undefined / empty-string values from a params object. */
function cleanParams(params) {
  const cleaned = {};
  for (const [k, v] of Object.entries(params || {})) {
    if (v === undefined || v === null || v === '') continue;
    cleaned[k] = typeof v === 'boolean' ? (v ? '1' : '0') : v;
  }
  return cleaned;
}

/**
 * GET /report-builder/charts/{path}
 *
 * @param {string} path     Chart endpoint name (e.g. 'outcome-measures', 'activity-types')
 * @param {object} params   Query parameters
 * @returns {Promise<object>} Parsed JSON response body
 */
export async function chartApiGet(path, params = {}) {
  const res = await axios.get(`/report-builder/charts/${path}`, {
    params: cleanParams(params),
  });
  return res.data;
}

/**
 * GET /report-builder/{path}
 *
 * @param {string} path     Endpoint name (e.g. 'sector-list', 'activity-venues')
 * @param {object} params   Query parameters
 * @returns {Promise<object>} Parsed JSON response body
 */
export async function reportBuilderGet(path, params = {}) {
  const res = await axios.get(`/report-builder/${path}`, {
    params: cleanParams(params),
  });
  return res.data;
}

/**
 * PUT /report-builder/{path}
 *
 * @param {string} path     Endpoint name (e.g. 'preferences')
 * @param {object} params   Query parameters (e.g. { orgId })
 * @param {object} body     JSON request body
 * @returns {Promise<object>} Parsed JSON response body
 */
export async function reportBuilderPut(path, params = {}, body = {}) {
  const res = await axios.put(`/report-builder/${path}`, body, {
    params: cleanParams(params),
  });
  return res.data;
}
